export const toWhatsAppWebPhone = (phone: string) => String(phone || '').replace(/\D/g, '');

export const buildWhatsAppWebUrl = (phone: string, providedUrl?: string) => {
  const directUrl = String(providedUrl || '').trim();
  if (directUrl) return directUrl;
  const waPhone = toWhatsAppWebPhone(phone);
  return `https://web.whatsapp.com/send?phone=${encodeURIComponent(waPhone)}`;
};

export const openWhatsAppWebConversation = (phone: string, providedUrl?: string) => {
  const finalUrl = buildWhatsAppWebUrl(phone, providedUrl);
  window.open(finalUrl, '_blank', 'noopener,noreferrer');
  return finalUrl;
};
